import React from 'react';
import PropTypes from 'prop-types';
import { linkTeamHome, linkRosterMemberRegistrationForm } from 'utils/links';
import { displayMemberAge } from 'utils/member';

import InputCheckbox from 'shared/components/Form/InputCheckbox';
import {
  FontIconCommissioner,
  FontIconManager,
  FontIconCoach,
  FontIconPendingMemberAddition,
  FontIconPendingMemberRemoval,
} from 'shared/components/ReusedFontIcons';

import classes from './RosterListRow.module.scss';

const roleIcons = member => (
  <span>
    { member.isCommissioner && <FontIconCommissioner /> }

    { member.isManager && <FontIconManager /> }

    { member.isCoach && <FontIconCoach /> }
  </span>
);

const renderPendingMemberIcon = pendingMoveClassName => {
  if (pendingMoveClassName === 'pendingMove--toTeam') {
    return <FontIconPendingMemberAddition className="u-colorSecondary u-spaceRightXs" />;
  }
  if (pendingMoveClassName === 'pendingMove--fromTeam') {
    return <FontIconPendingMemberRemoval className="u-spaceRightXs" />;
  }
};

const renderTeamNameLink = (member, team) => {
  if (member.teamId && team) {
    return <a href={ linkTeamHome(team.id) }>{ team.name }</a>;
  }
  return 'Not Rostered';
};

const renderPendingLabel = (member, pendingTeam, pendingDivision, deletePendingMemberByMemberId) => {
  if (!member.isPending) {
    return null;
  }

  let pendingLocationName = null;
  if (pendingDivision && !pendingTeam) {
    pendingLocationName = pendingDivision.name;
  } else if (pendingTeam) {
    pendingLocationName = pendingTeam.name;
  }

  let cancelLink = null;
  if (deletePendingMemberByMemberId) {
    cancelLink = (
      <div className="u-spaceTopXs">
        <a className="u-colorNegative" onClick={ deletePendingMemberByMemberId }>
          Cancel
        </a>
      </div>
    );
  }

  return (
    <div>
      <span className={ classes.pendingLabel }>(pending to { pendingLocationName })</span>
      { cancelLink }
    </div>
  );
};

const renderRegFormNameLink = (registrationForm, registrationVersion) => {
  if (registrationForm && registrationForm.name) {
    if (registrationVersion === 1){
      const link = linkRosterMemberRegistrationForm(registrationForm.divisionId, registrationForm.id);
      return <a href={link}>{registrationForm.name}</a>;
    } else if (registrationVersion === 2) {
      const link = `${window.TeamSnap.organizationJsUrl}/organizations/${window.TeamSnap.organizationId}/registration/${registrationForm.id}/details`;
      return <a href={link}>{registrationForm.name}</a>;
    } else {
      return '-';
    }
  }

  return 'No Form';
};

const RosterMemberRow = ({
  checkboxHandler,
  checkboxIsChecked,
  className,
  currentMember,
  member,
  registrationForm,
  showCheckbox,
  style,
  team,
  division,
  pendingDivision,
  pendingTeam,
  toggleSelectMember,
  pendingMoveClassName,
  deletePendingMemberByMemberId,
  registrationVersion,
  shouldShowRegFormColumn,
}) => (
  <tr
    className={ `${classes.rosterListItem} ${className} ${pendingMoveClassName ? classes[pendingMoveClassName] : ''}` }
    style={ style }
  >
    <td className={ shouldShowRegFormColumn ? classes['col-player-name-with-form'] : classes['col-player-name'] } onClick={ toggleSelectMember }>
      { renderPendingMemberIcon(pendingMoveClassName) }
      <span className={ classes.memberName }>{ member.firstName }</span>
      { !member.lastName && roleIcons(member) }
    </td>
    <td className={ shouldShowRegFormColumn ? classes['col-player-name-with-form'] : classes['col-player-name'] } onClick={ toggleSelectMember }>
      <span className={ classes.memberName }>{ member.lastName }</span>
      { member.lastName && roleIcons(member) }
    </td>
    <td className={ classes['col-player-gender'] } onClick={ toggleSelectMember }>
      { member.gender }
    </td>
    <td className={ classes['col-player-age'] } onClick={ toggleSelectMember }>
      { displayMemberAge(member, currentMember, '-') }
    </td>
    <td className={ shouldShowRegFormColumn ? classes['col-player-team-with-form'] : classes['col-player-team'] } onClick={ toggleSelectMember }>
      { renderTeamNameLink(member, team, pendingTeam) }
      { renderPendingLabel(member, pendingTeam, pendingDivision, deletePendingMemberByMemberId) }
    </td>
    { shouldShowRegFormColumn &&
      <td className={classes['col-player-reg-form']} onClick={toggleSelectMember}>
        { renderRegFormNameLink(registrationForm, registrationVersion) }
      </td>
    }
    { showCheckbox && (
      <td className={ classes['col-player-select'] }>
        <InputCheckbox
          checked={ checkboxIsChecked }
          updateHandler={ checkboxHandler }
          name="player_select"
          disabled={ member.isCommissioner }
          title={ member.isCommissioner ? 'Cannot Assign Commissioner' : '' }
        />
      </td>
    ) }
  </tr>
);

RosterMemberRow.propTypes = {
  checkboxHandler: PropTypes.func,
  checkboxIsChecked: PropTypes.bool,
  className: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  currentMember: PropTypes.object,
  member: PropTypes.object.isRequired,
  registrationForm: PropTypes.object,
  showCheckbox: PropTypes.bool,
  style: PropTypes.object,
  team: PropTypes.shape({}),
  teamName: PropTypes.shape({}),
  pendingDivision: PropTypes.shape({}),
  pendingTeam: PropTypes.shape({}),
  division: PropTypes.object,
  toggleSelectMember: PropTypes.func,
  pendingMoveClassName: PropTypes.string,
  deletePendingMemberByMemberId: PropTypes.func,
  registrationVersion: PropTypes.number,
  shouldShowRegFormColumn: PropTypes.bool.isRequired,
};

export default RosterMemberRow;
